import { useEffect } from "react"

const GlobalErrorMessage = () => {
  useEffect(() => {
    $('.modal-backdrop').addClass('with-global-error')
    return () => {
      $('.modal-backdrop').removeClass('with-global-error')
    }
  }, [])

  const okay = () => {
    App.state.setError(null)
  }

  let { error } = App.state
  if (!error) return null
  return (
    <div className="global-error-message">
      <div className="global-error-message-text alert alert-danger">{error.message}</div>
      <div className="global-error-message-actions">
        <button className='btn btn-sm btn-primary' onClick={okay}>Okay</button>
      </div>
    </div>
  )
}

export default GlobalErrorMessage
